var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-95106e0c!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.vue
// module id = 435
// module chunks = 81